enum DeleteFromWebflowTypeEnum {
  Featured = 'Featured',
  AssetClass = 'AssetClass',
  Custom = 'Custom',
}

export default DeleteFromWebflowTypeEnum;
